<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item>申请理赔</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<!-- 测试按钮 -->
			<div class="test-buttons" v-if="active == 1">
				<el-button type="warning" size="small" @click="fillTestData">填充测试数据</el-button>
				<el-button type="info" size="small" @click="clearFormData">清空表单</el-button>
			</div>

			<div class="box">
				<div class="steps">
					<div class="operate"></div>
					<el-steps :active="active" align-center>
						<el-step title="填写资料" />
						<el-step title="上传资料" />
						<el-step title="提交完成" />
					</el-steps>
					
					<div class="operate">
						<div v-if="active == 1" class="btn cancel" @click="$back()">
							取消
						</div>
						<div v-if="active > 1 && active < 3" class="btn cancel" @click="active --">
							上一步
						</div>
						<div v-if="active < 2" class="btn confirm" @click="nextStep">
							下一步
						</div>
						<div v-if="active == 2" class="btn confirm" @click="submitClaim">
							提交申请
						</div>
					</div>
				</div>
				
				<!-- 第一步：填写资料 -->
				<div v-if="active == 1">
					<div class="box-title">
						理赔保单
					</div>
					<el-form :model="claimForm" :rules="rules" ref="form1" :inline="true" class="form">
						<el-form-item label="理赔保单" prop="order_id" size="medium">
							<el-select v-model="claimForm.order_id" placeholder="请选择理赔保单" @change="handleOrderChange">
							    <el-option 
									v-for="(item, index) in orderList" 
									:key="index" 
									:value="item.id" 
									:label="(item.goods_name + ' ' + item.goods_specs_name)"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
					
					<div class="box-title">
						出险人信息
					</div>
					<el-form :model="claimForm" :rules="rules" ref="form2" :inline="true" class="form">
						<el-form-item label="出险人姓名" prop="insurant_name" size="medium">
							<el-input v-model="claimForm.insurant_name" placeholder="请输入被保险人姓名" @blur="validateName('insurant_name')"/>
						</el-form-item>
						<el-form-item label="证件类型" prop="insurant_cert_type" size="medium">
							<el-select v-model="claimForm.insurant_cert_type" placeholder="请选择证件类型" @change="handleCertTypeChange">
							    <el-option label="身份证" value="01"></el-option>
								<el-option label="护照" value="02"></el-option>
								<el-option label="港澳居民往来内地通行证" value="03"></el-option>
								<el-option label="台湾居民往来大陆通行证" value="04"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="证件号码" prop="insurant_cert_no" size="medium">
							<el-input v-model="claimForm.insurant_cert_no" placeholder="请输入证件号码" @blur="validateCertNo"/>
						</el-form-item>
						<el-form-item label="报案人电话" prop="reporter_telephone" size="medium">
							<el-input v-model="claimForm.reporter_telephone" placeholder="请输入报案人电话"/>
						</el-form-item>
					</el-form>
					
					<div class="box-title">
						理赔信息
					</div>
					<el-form :model="claimForm" :rules="rules" ref="form3" :inline="true" class="form">
						<el-form-item label="报案地点" prop="regist_address" size="medium">
							<el-input v-model="claimForm.regist_address" placeholder="请输入报案地点"/>
						</el-form-item>
						<el-form-item label="报案人姓名" prop="reporter" size="medium">
							<el-input v-model="claimForm.reporter" placeholder="请输入报案人姓名" @blur="validateName('reporter')"/>
						</el-form-item>
					</el-form>
					<el-form :model="claimForm" :rules="rules" ref="form4" :inline="true" class="form">
						<el-form-item label="出险经过" prop="accident_desc" size="medium">
							<el-input class="textarea" v-model="claimForm.accident_desc" type="textarea" :rows="8" placeholder="请详细描述出险经过"/>
						</el-form-item>
					</el-form>
					
					<div class="box-title">
						理赔收款账户
					</div>
					<el-form :model="claimForm" :rules="rules" ref="form5" :inline="true" class="form">
						<el-form-item label="账户名" prop="account_name" size="medium">
							<el-input v-model="claimForm.account_name" placeholder="请输入收款人名称" @blur="validateAccountName"/>
						</el-form-item>
						<el-form-item label="银行卡号" prop="account_code" size="medium">
							<el-input v-model="claimForm.account_code" placeholder="请输入开户行账号" @blur="validateBankCard"/>
						</el-form-item>
						<el-form-item label="开户行" prop="bank_name_cn" size="medium">
							<el-input v-model="claimForm.bank_name_cn" placeholder="请输入开户行名称"/>
						</el-form-item>
						<el-form-item label="银行名称" prop="formal_bank_bame_cn" size="medium">
							<el-input v-model="claimForm.formal_bank_bame_cn" placeholder="请输入银行名称"/>
						</el-form-item>
						<el-form-item label="开户省份" prop="deposit_bank_province" size="medium">
							<el-input v-model="claimForm.deposit_bank_province" placeholder="请输入开户行所在省份"/>
						</el-form-item>
						<el-form-item label="开户城市" prop="deposit_bank_city" size="medium">
							<el-input v-model="claimForm.deposit_bank_city" placeholder="请输入开户行所在城市"/>
						</el-form-item>
					</el-form>
					
					<div class="box-title">
						理赔注意事项
					</div>
					<div class="notice">
						{{ $getter('setting').value7 }}
					</div>
				</div>
				
				<!-- 第二步：上传资料 -->
				<div v-if="active == 2">
					<!-- 测试文件按钮 -->
					<div class="test-buttons">
						<el-button type="warning" size="small" @click="fillTestFileData">填充测试文件数据</el-button>
					</div>
					
					<div class="box-title">
						门诊病历<div>示例</div>
					</div>
					<div class="file-title">请提供门诊病历</div>
					<page-images :limit="1" v-model="claimForm.outpatient_record_file" />
					
					<div class="box-title">
						医疗费用发票<div>示例</div>
					</div>
					<div class="file-title">请提供医疗费用发票</div>
					<page-images :limit="1" v-model="claimForm.medical_invoice_file" />
					
					<div class="box-title">
						费用明细清单<div>示例</div>
					</div>
					<div class="file-title">请提供费用明细清单</div>
					<page-images :limit="1" v-model="claimForm.cost_detail_file" />
					
					<div class="box-title">
						检查报告<div>示例</div>
					</div>
					<div class="file-title">请提供检查报告</div>
					<page-images :limit="1" v-model="claimForm.check_report_file" />
				</div>
				
				<!-- 第三步：提交完成 -->
				<div v-if="active == 3">
					<el-result icon="success" title="提交申请成功" subTitle="等待审核">
						<template slot="extra">
							<el-button @click="$back()" type="primary" size="medium">返回</el-button>
						</template>
					</el-result>
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			// ... 原有的校验函数保持不变 ...
			// 身份证校验函数
			const validateIDCard = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入身份证号码'));
					return;
				}
				// 身份证简单校验（15位或18位）
				const idCardPattern = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
				if (!idCardPattern.test(value)) {
					callback(new Error('请输入正确的身份证号码'));
				} else {
					callback();
				}
			};

			// 护照校验函数
			const validatePassport = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入护照号码'));
					return;
				}
				// 护照号码校验（字母开头，后面跟数字或字母）
				const passportPattern = /^[a-zA-Z][a-zA-Z0-9]{5,17}$/;
				if (!passportPattern.test(value)) {
					callback(new Error('请输入正确的护照号码'));
				} else {
					callback();
				}
			};

			// 港澳通行证校验
			const validateHKMacaoPass = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入港澳居民往来内地通行证号码'));
					return;
				}
				// 港澳通行证格式：H/M开头，后面跟8位数字
				const hkMacaoPattern = /^[HMhm]\d{8}$/;
				if (!hkMacaoPattern.test(value)) {
					callback(new Error('请输入正确的港澳居民往来内地通行证号码'));
				} else {
					callback();
				}
			};

			// 台湾通行证校验
			const validateTaiwanPass = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入台湾居民往来大陆通行证号码'));
					return;
				}
				// 台湾通行证格式：8位数字
				const taiwanPattern = /^\d{8}$/;
				if (!taiwanPattern.test(value)) {
					callback(new Error('请输入正确的台湾居民往来大陆通行证号码'));
				} else {
					callback();
				}
			};

			// 银行卡号校验
			const validateBankCard = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入银行卡号'));
					return;
				}
				// 银行卡号校验（16-19位数字）
				const bankCardPattern = /^\d{16,19}$/;
				if (!bankCardPattern.test(value)) {
					callback(new Error('请输入正确的银行卡号（16-19位数字）'));
				} else {
					callback();
				}
			};

			// 中文姓名校验
			const validateChineseName = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入姓名'));
					return;
				}
				const chineseNamePattern = /^[\u4e00-\u9fa5]{2,20}$/;
				if (!chineseNamePattern.test(value)) {
					callback(new Error('请输入正确的中文姓名（2-20个汉字）'));
				} else {
					callback();
				}
			};

			// 英文姓名校验
			const validateEnglishName = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入姓名'));
					return;
				}
				const englishNamePattern = /^[a-zA-Z\s]{2,50}$/;
				if (!englishNamePattern.test(value)) {
					callback(new Error('请输入正确的英文姓名（2-50个英文字母）'));
				} else {
					callback();
				}
			};

			// 账户名校验（支持中文和英文）
			const validateAccountName = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入账户名'));
					return;
				}
				const accountNamePattern = /^[\u4e00-\u9fa5a-zA-Z\s]{2,50}$/;
				if (!accountNamePattern.test(value)) {
					callback(new Error('账户名只能包含中文、英文字母和空格（2-50个字符）'));
				} else {
					callback();
				}
			};

			return {
				active: 1,
				orderForm: {
					_page: 0,
					_order: 'id',
					_isreverse: 1,
					status: 2,
				},
				orderList: [],
				claimForm: {
					order_id: '',
					insurant_name: '',
					insurant_cert_type: '',
					insurant_cert_no: '',
					reporter: '',
					reporter_telephone: '',
					regist_time: this.getCurrentTime(),
					regist_address: '',
					accident_desc: '',
					account_name: '',
					account_code: '',
					bank_name_cn: '',
					formal_bank_bame_cn: '',
					deposit_bank_province: '',
					deposit_bank_city: '',
					outpatient_record_file: '',
					medical_invoice_file: '',
					cost_detail_file: '',
					check_report_file: '',
					file_list: '',
					settle_status: 0,
				},
				rules: {
					// ... 原有的校验规则保持不变 ...
					order_id: [
						{ required: true, message: '请选择理赔保单', trigger: 'change' }
					],
					insurant_name: [
						{ required: true, message: '请输入出险人姓名', trigger: 'blur' },
						{ validator: validateChineseName, trigger: 'blur' }
					],
					insurant_cert_type: [
						{ required: true, message: '请选择证件类型', trigger: 'change' }
					],
					insurant_cert_no: [
						{ required: true, message: '请输入证件号码', trigger: 'blur' }
					],
					reporter: [
						{ required: true, message: '请输入报案人姓名', trigger: 'blur' },
						{ validator: validateChineseName, trigger: 'blur' }
					],
					reporter_telephone: [
						{ required: true, message: '请输入报案人电话', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
					],
					regist_address: [
						{ required: true, message: '请输入报案地点', trigger: 'blur' },
						{ min: 2, max: 100, message: '报案地点长度为2-100个字符', trigger: 'blur' }
					],
					accident_desc: [
						{ required: true, message: '请输入出险经过', trigger: 'blur' },
						{ min: 10, max: 1000, message: '出险经过长度为10-1000个字符', trigger: 'blur' }
					],
					account_name: [
						{ required: true, message: '请输入账户名', trigger: 'blur' },
						{ validator: validateAccountName, trigger: 'blur' }
					],
					account_code: [
						{ required: true, message: '请输入银行卡号', trigger: 'blur' },
						{ validator: validateBankCard, trigger: 'blur' }
					],
					bank_name_cn: [
						{ required: true, message: '请输入开户行', trigger: 'blur' },
						{ min: 2, max: 50, message: '开户行长度为2-50个字符', trigger: 'blur' }
					],
					formal_bank_bame_cn: [
						{ required: true, message: '请输入银行名称', trigger: 'blur' },
						{ min: 2, max: 50, message: '银行名称长度为2-50个字符', trigger: 'blur' }
					],
					deposit_bank_province: [
						{ required: true, message: '请输入开户省份', trigger: 'blur' },
						{ min: 2, max: 20, message: '开户省份长度为2-20个字符', trigger: 'blur' }
					],
					deposit_bank_city: [
						{ required: true, message: '请输入开户城市', trigger: 'blur' },
						{ min: 2, max: 20, message: '开户城市长度为2-20个字符', trigger: 'blur' }
					]
				},
				// 证件类型对应的校验规则
				certTypeRules: {
					'01': validateIDCard,      // 身份证
					'02': validatePassport,    // 护照
					'03': validateHKMacaoPass, // 港澳通行证
					'04': validateTaiwanPass   // 台湾通行证
				}
			}
		},
		mounted() {
			this.ActionList();
		},
		methods: {
			// 填充测试数据
			fillTestData() {
				const testData = {
					order_id: this.orderList.length > 0 ? this.orderList[0].id : 1,
					insurant_name: '张三',
					insurant_cert_type: '01',
					insurant_cert_no: '110101199001011234',
					reporter: '李四',
					reporter_telephone: '13800138000',
					regist_time: this.getCurrentTime(),
					regist_address: '北京市朝阳区建国路100号',
					accident_desc: '2024年1月15日下午3点左右，被保险人在家中不慎滑倒，导致右手腕部疼痛肿胀。立即前往北京协和医院急诊科就诊，经X光检查确诊为右手腕骨折。医生进行了石膏固定处理，并开具了相关药物。整个治疗过程持续约3小时，医疗费用共计2850元。',
					account_name: '张三',
					account_code: '6222021000001234567',
					bank_name_cn: '中国工商银行北京分行朝阳支行',
					formal_bank_bame_cn: '中国工商银行',
					deposit_bank_province: '北京市',
					deposit_bank_city: '北京市'
				};
				
				Object.keys(testData).forEach(key => {
					if (this.claimForm.hasOwnProperty(key)) {
						this.claimForm[key] = testData[key];
					}
				});
				
				this.$message.success('测试数据填充完成');
			},

			// 填充测试文件数据
			fillTestFileData() {
				const testFileData = {
					outpatient_record_file: 'https://example.com/images/outpatient_record.jpg',
					medical_invoice_file: 'https://example.com/images/medical_invoice.jpg',
					cost_detail_file: 'https://example.com/images/cost_detail.jpg',
					check_report_file: 'https://example.com/images/check_report.jpg'
				};
				
				Object.keys(testFileData).forEach(key => {
					if (this.claimForm.hasOwnProperty(key)) {
						this.claimForm[key] = testFileData[key];
					}
				});
				
				this.$message.success('测试文件数据填充完成');
			},

			// 清空表单数据
			clearFormData() {
				this.claimForm = {
					order_id: '',
					insurant_name: '',
					insurant_cert_type: '',
					insurant_cert_no: '',
					reporter: '',
					reporter_telephone: '',
					regist_time: this.getCurrentTime(),
					regist_address: '',
					accident_desc: '',
					account_name: '',
					account_code: '',
					bank_name_cn: '',
					formal_bank_bame_cn: '',
					deposit_bank_province: '',
					deposit_bank_city: '',
					outpatient_record_file: '',
					medical_invoice_file: '',
					cost_detail_file: '',
					check_report_file: '',
					file_list: '',
					settle_status: 0,
				};
				this.$message.success('表单数据已清空');
			},

			// 获取当前时间
			getCurrentTime() {
				const now = new Date();
				return now.getFullYear() + '-' + 
					   String(now.getMonth() + 1).padStart(2, '0') + '-' + 
					   String(now.getDate()).padStart(2, '0') + ' ' + 
					   String(now.getHours()).padStart(2, '0') + ':' + 
					   String(now.getMinutes()).padStart(2, '0') + ':' + 
					   String(now.getSeconds()).padStart(2, '0');
			},

			// 证件类型变化
			handleCertTypeChange(value) {
				// 清空证件号码
				this.claimForm.insurant_cert_no = '';
				// 更新证件号码的校验规则
				this.updateCertNoValidation();
			},

			// 更新证件号码校验规则
			updateCertNoValidation() {
				const certType = this.claimForm.insurant_cert_type;
				const certNoRule = this.rules.insurant_cert_no;
				
				// 清空原有的自定义校验器
				certNoRule.forEach((rule, index) => {
					if (rule.validator) {
						certNoRule.splice(index, 1);
					}
				});

				// 添加新的校验规则
				if (certType && this.certTypeRules[certType]) {
					certNoRule.push({
						validator: this.certTypeRules[certType],
						trigger: 'blur'
					});
				}
			},

			// 验证证件号码
			validateCertNo() {
				this.updateCertNoValidation();
			},

			// 验证姓名
			validateName(fieldName) {
				const value = this.claimForm[fieldName];
				if (!value) return;
				
				// 检查是否包含中文
				const hasChinese = /[\u4e00-\u9fa5]/.test(value);
				if (hasChinese) {
					// 中文姓名校验
					const chineseNamePattern = /^[\u4e00-\u9fa5]{2,20}$/;
					if (!chineseNamePattern.test(value)) {
						this.$message.error('请输入正确的中文姓名（2-20个汉字）');
					}
				} else {
					// 英文姓名校验
					const englishNamePattern = /^[a-zA-Z\s]{2,50}$/;
					if (!englishNamePattern.test(value)) {
						this.$message.error('请输入正确的英文姓名（2-50个英文字母）');
					}
				}
			},

			// 验证账户名
			validateAccountName() {
				const value = this.claimForm.account_name;
				if (!value) return;
				
				const accountNamePattern = /^[\u4e00-\u9fa5a-zA-Z\s]{2,50}$/;
				if (!accountNamePattern.test(value)) {
					this.$message.error('账户名只能包含中文、英文字母和空格（2-50个字符）');
				}
			},

			// 验证银行卡号
			validateBankCard() {
				const value = this.claimForm.account_code;
				if (!value) return;
				
				const bankCardPattern = /^\d{16,19}$/;
				if (!bankCardPattern.test(value)) {
					this.$message.error('请输入正确的银行卡号（16-19位数字）');
				}
			},

			// 下一步
			nextStep() {
				// 验证所有表单
				const formRefs = ['form1', 'form2', 'form3', 'form4', 'form5'];
				let allValid = true;
				
				const validatePromises = formRefs.map(ref => {
					return new Promise((resolve) => {
						if (this.$refs[ref]) {
							this.$refs[ref].validate((valid) => {
								if (!valid) {
									allValid = false;
								}
								resolve();
							});
						} else {
							resolve();
						}
					});
				});
				
				Promise.all(validatePromises).then(() => {
					if (allValid) {
						this.active++;
					} else {
						this.$message.error('请完善表单信息');
						this.scrollToFirstError();
					}
				});
			},
			
			// 滚动到第一个错误表单项
			scrollToFirstError() {
				this.$nextTick(() => {
					const firstError = document.querySelector('.el-form-item__error');
					if (firstError) {
						firstError.scrollIntoView({ 
							behavior: 'smooth', 
							block: 'center' 
						});
					}
				});
			},
			
			// 提交理赔申请
			submitClaim() {
				// 验证必填文件
				if (!this.claimForm.outpatient_record_file) {
					this.$message.error('请上传门诊病历');
					return;
				}
				if (!this.claimForm.medical_invoice_file) {
					this.$message.error('请上传医疗费用发票');
					return;
				}
				if (!this.claimForm.cost_detail_file) {
					this.$message.error('请上传费用明细清单');
					return;
				}
				
				// 组合文件列表
				this.combineFileList();
				
				// 这里可以取消注释来提交数据
				this.$load();
				this.$post('app-order-claim', this.claimForm, true).then(res => {
					this.active++;
					this.$message.success('理赔申请提交成功');
				}).catch(err => {
					this.$message.error(err);
				})
			},
			
			// 组合文件列表
			combineFileList() {
			    let fileList = [];
			    
			    // 定义所有文件字段
			    const fileFields = [
			        { field: 'outpatient_record_file', name: '门诊病历' },
			        { field: 'medical_invoice_file', name: '医疗费用发票' },
			        { field: 'cost_detail_file', name: '费用明细清单' },
			        { field: 'check_report_file', name: '检查报告' }
			    ];
			    
			    fileFields.forEach(item => {
			        const fileUrl = this.claimForm[item.field];
			        if (fileUrl && fileUrl.trim() !== '') {
			            // 确保URL是有效的
			            if (fileUrl.startsWith('http') || fileUrl.startsWith('https') || fileUrl.startsWith('/')) {
			                fileList.push(fileUrl);
			            }
			        }
			    });
			    
			    this.claimForm.file_list = fileList.length > 0 ? JSON.stringify(fileList) : '';
			},
			
			// 保单选择变化
			handleOrderChange(orderId) {
				const selectedOrder = this.orderList.find(item => item.id === orderId);
				if (selectedOrder) {
					// 自动填充被保险人信息
					this.claimForm.insurant_name = selectedOrder.insurant_name || '';
					this.claimForm.insurant_cert_type = selectedOrder.insurant_cert_type || '';
					this.claimForm.insurant_cert_no = selectedOrder.insurant_cert_no || '';
					this.claimForm.policy_no = selectedOrder.policy_no || '';
				}
			},
			
			ActionList(){
				this.$load();
				this.$get('app-order', this.orderForm, true).then(res => {
					this.orderList = res.data;
				}).catch(err => {
					this.$message.error(err);
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			// 笔记本适配
			@media (max-width: 1440px) {
				width: 80%;
			}
			
			@media (max-width: 1280px) {
				width: 90%;
			}
			
			@media (max-width: 1024px) {
				width: 95%;
				margin: 15px auto 30px;
			}

			.test-buttons {
				margin-bottom: 15px;
				text-align: right;
				.el-button {
					margin-left: 10px;
				}
			}

			.box {
				margin-top: 20px;
				padding: 20px;
				background-color: #fff;
				border-radius: 10px;

				// 笔记本适配
				@media (max-width: 1024px) {
					padding: 15px;
					margin-top: 15px;
				}

				.box-title {
					color: #333333;
					font-size: 20px;
					font-weight: bold;
					margin: 20px 0;
					display: flex;
					justify-content: space-between;
					align-items: center;
					
					// 笔记本适配
					@media (max-width: 1280px) {
						font-size: 18px;
						margin: 15px 0;
					}
					
					div {
						color: #999999;
						font-size: 14px;
						padding: 6px 20px;
						background-color: #F7F7F7;
						font-weight: 500;
						border-radius: 5px;
						cursor: pointer;
						
						// 笔记本适配
						@media (max-width: 1280px) {
							padding: 5px 15px;
							font-size: 13px;
						}
					}
				}

				.steps {
					padding-bottom: 20px;
					border-bottom: 1px solid #EEEEEE;
					display: flex;
					align-items: center;
					justify-content: space-between;
					
					// 笔记本适配
					@media (max-width: 1280px) {
						padding-bottom: 15px;
						flex-direction: column;
						gap: 15px;
					}

					.el-steps {
						width: 60%;
						
						// 笔记本适配
						@media (max-width: 1280px) {
							width: 100%;
						}
						
						@media (max-width: 768px) {
							:deep(.el-step) {
								.el-step__title {
									font-size: 14px;
								}
							}
						}
					}
					
					.operate {
						display: flex;
						gap: 20px;
						width: 20%;
						
						// 笔记本适配
						@media (max-width: 1280px) {
							width: 100%;
							justify-content: center;
						}
						
						@media (max-width: 768px) {
							gap: 15px;
						}

						.btn {
							width: 120px;
							line-height: 40px;
							text-align: center;
							border-radius: 50px;
							cursor: pointer;
							
							// 笔记本适配
							@media (max-width: 768px) {
								width: 110px;
								line-height: 36px;
								font-size: 14px;
							}
						}
						
						.cancel {
							background-color: #fff;
							border: 1px solid #CCCCCC;
							color: #999;
						}
						
						.confirm {
							background-color: #2280FD;
							border: 1px solid #2280FD;
							color: #fff;
						}
					}
					
					:deep(.el-step) {
						.el-step__head {
							color: #999999;
							border-color: #999999;
						}
						.el-step__title {
							color: #999999;
							font-weight: 500;
						}
						.el-step__title.is-finish {
							color: #2280FD;
						}
						.el-step__head.is-finish {
							color: #2280FD;
							border-color: #2280FD;
						}
						.el-step__head.is-process {
							color: #999999;
							border-color: #999999;
						}
						.el-step__title.is-process {
							color: #999999;
							font-weight: 500;
						}
					}
				}
				
				.form {
					.el-form-item {
						width: 600px;
						
						// 笔记本适配 - 逐步减小宽度但保持两列布局
						@media (max-width: 1440px) {
							width: 550px;
						}
						
						@media (max-width: 1366px) {
							width: 520px;
						}
						
						@media (max-width: 1280px) {
							width: 480px;
						}

						.el-select {
							width: 400px;
							
							// 笔记本适配 - 逐步减小宽度
							@media (max-width: 1440px) {
								width: 350px;
							}
							
							@media (max-width: 1366px) {
								width: 320px;
							}
							
							@media (max-width: 1280px) {
								width: 280px;
							}
						}
						
						.textarea {
							width: 400px;
							
							// 笔记本适配 - 逐步减小宽度
							@media (max-width: 1440px) {
								width: 350px;
							}
							
							@media (max-width: 1366px) {
								width: 320px;
							}
							
							@media (max-width: 1280px) {
								width: 280px;
							}
						}
						
						.el-input {
							width: 400px;
							
							// 笔记本适配 - 逐步减小宽度
							@media (max-width: 1440px) {
								width: 350px;
							}
							
							@media (max-width: 1366px) {
								width: 320px;
							}
							
							@media (max-width: 1280px) {
								width: 280px;
							}
						}
						
						::v-deep .el-form-item__label {
							color: #999999 !important;
							font-size: 16px;
							width: 120px;
							text-align: left;
							
							// 笔记本适配
							@media (max-width: 1366px) {
								font-size: 15px;
								width: 110px;
							}
						}
					}
					
					// 在更小的屏幕尺寸下才改为单行布局
					@media (max-width: 1024px) {
						:deep(.el-form--inline .el-form-item) {
							display: block;
							margin-right: 0;
							margin-bottom: 15px;
							
							.el-select,
							.el-input,
							.textarea {
								width: 100% !important;
							}
						}
					}
					
					// 在768px以下进一步调整
					@media (max-width: 768px) {
						:deep(.el-form-item__label) {
							width: 100px !important;
							font-size: 14px !important;
						}
					}
				}
				
				.notice {
					background-color: #F7F7F7;
					padding: 20px;
					
					// 笔记本适配
					@media (max-width: 1280px) {
						padding: 15px;
					}
				}
				
				.file-title {
					color: #666666;
					font-size: 16px;
					margin: 10px 0;
					
					// 笔记本适配
					@media (max-width: 1280px) {
						font-size: 15px;
					}
				}
				
				:deep(.el-result) {
					.icon-success {
						fill: #2280FD;
					}
					.el-button {
						background-color: #2280FD;
					}
				}
			}
		}
	}
</style>